import React from 'react';
import { Container } from 'reactstrap';
import AdminHeader from 'components/organisms/adminHeader';
import AdminPatientBlock from 'components/templates/admin/patient';

const AdminPatient = () => (
  <Container>
    <AdminHeader />
    <AdminPatientBlock />
  </Container>
);

export default AdminPatient;
